import { render, staticRenderFns } from "./ArchiveSharedDrive.vue?vue&type=template&id=04e56d17"
import script from "./ArchiveSharedDrive.vue?vue&type=script&lang=js"
export * from "./ArchiveSharedDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports